import { render } from "./wallet_add.vue?vue&type=template&id=33963eb5"
import script from "./wallet_add.vue?vue&type=script&lang=js"
export * from "./wallet_add.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__